import React, { useCallback } from "react"
import { SortableTh } from "../../components/SortableColumns"
import { GenericOverview } from "../../components/Table/GenericOverview"
import { useNavigate } from "react-router-dom"
import { Col, Row } from "react-bootstrap"
import { GenericLinks } from "../../components/Table/GenericLink"
import { useRole } from "../../components/RoleContext"
import { hasAnyRequiredPermission, RoleProtect } from "../../components/Authorization/RoleProtect"
import { Permission } from "../../api"

export const RolesOverview = () => {
    const endpoint = "/v2/management/roles"
    const navigate = useNavigate()
    const jsonDataField = (setData, data) => setData(data)
    const { permissions } = useRole()

    const error = {
        title: "Failed to get roles",
        body: "Something went wrong while getting the roles, see the console for more details.",
    }

    const toPermissions = useCallback((id) => navigate(`/roles/${id}`), [navigate])

    const table = {
        header: [
            <SortableTh column="name">Name</SortableTh>,
            <RoleProtect allowedPermissions={[Permission.SetAnyResourceRoles]}>
                <th>Actions</th>
            </RoleProtect>,
        ],
        body: useCallback(
            (value) => {
                const canChange = new Set(permissions).isSupersetOf(new Set(value.permissions))
                return (
                    <tr
                        onClick={
                            canChange &&
                            hasAnyRequiredPermission([Permission.SetAnyResourceRoles], permissions)
                                ? () => toPermissions(value.id)
                                : undefined
                        }
                        key={value.name}
                    >
                        <td>{value.name}</td>
                        <RoleProtect allowedPermissions={[Permission.SetAnyResourceRoles]}>
                            <td>
                                {canChange && (
                                    <GenericLinks
                                        items={[
                                            {
                                                onClick: () => {
                                                    toPermissions(value.id)
                                                },
                                                text: "Permissions",
                                            },
                                        ]}
                                    />
                                )}
                            </td>
                        </RoleProtect>
                    </tr>
                )
            },
            [permissions, toPermissions]
        ),
    }

    return (
        <Row className="content-section">
            <Col>
                <h2>Roles</h2>
                <GenericOverview
                    apiEndpoint={endpoint}
                    dataField={jsonDataField}
                    filter={[]}
                    error={error}
                    pagination={false}
                    disableSearch={true}
                    table={table}
                />
            </Col>
        </Row>
    )
}
